import React, { Fragment } from 'react';
import { defaultTemplate, withAuth } from 'core/hoc';
import { PropTypes } from 'prop-types';

const iconName = name => (name ? '' + name : '');

const BaasicButtonTemplate = function(
    {
        onClick,
        authorization,
        ...otherProps
    }){
    return (        
        <AuthContent authorization={authorization} onAction={onClick} {...otherProps}/>
    );
}

BaasicButtonTemplate.propTypes = {
    onClick: PropTypes.func,
    authorization: PropTypes.any
};

const AuthContent = withAuth(DefaultContent);

function DefaultContent({
    onlyIcon = false,
    disabled = false,
    content = null,
    type = 'button',
    className,
    onAction,
    label,
    icon= 'u-display--none',
    t,
    authorized = true,
    focused,
    showTooltip = true,
}){
    return onAction && authorized ? 
    <button
            type={type}
            disabled={disabled}
            onClick={onAction}
            className={className}
            title={showTooltip ? t(label) : ''}
            autoFocus={focused}
        >
            {content || (
                <Fragment>
                    <span className={`${iconName(icon)}`} />
                    {!onlyIcon && t(label)}
                </Fragment>
            )}
        </button>
        : null;
}

DefaultContent.propTypes = {
    onlyIcon: PropTypes.bool,
    disabled: PropTypes.bool,
    content: PropTypes.any,
    type: PropTypes.string,
    className: PropTypes.string,
    onAction: PropTypes.func,
    label: PropTypes.string,
    icon: PropTypes.string,
    t: PropTypes.func,
    authorized:PropTypes.any,
    focused: PropTypes.bool,
    showTooltip: PropTypes.bool
};

export default defaultTemplate(BaasicButtonTemplate);
